module.exports = __webpack_public_path__ + "img/index-reading.51240f23.svg";